import { put, get, post, del } from './requests.js'

export const createApiKey = ({ env, id, created_by, name }) =>
  put(
    [`source-partners/${id}/api-key?env=${env}`],
    { removeTrailingSlash: true, transformPayload: false },
    { name, created_by }
  )

export const updateSourcePartner = (env, id, body) =>
  put(
    [`source-partners/${id}?env=${env}`],
    { removeTrailingSlash: true, transformPayload: true },
    body
  )

export const getSourcePartners = (env) =>
  get([`source-partners?env=${env}`], {
    removeTrailingSlash: true,
  })

export const getActiveSourcePartners = (env) =>
  get([`source-partners?fields=name&fields=mapping_ids&is_active=true&env=${env}`], {
    removeTrailingSlash: true,
  })

export const getSourcePartnersById = (env, id) =>
  get([`source-partners/${id}?env=${env}`], {
    removeTrailingSlash: true,
  })

export const getS3AccessKeys = (env, id) =>
  get([`source-partners/${id}/s3-access-keys?env=${env}`], {
    removeTrailingSlash: true,
  })

export const createS3AccessKeys = (env, id) =>
  post([`source-partners/${id}/s3-access-keys?env=${env}`], {
    removeTrailingSlash: true,
  })

export const deleteS3AccessKeys = (env, id, key) =>
  del([`source-partners/${id}/s3-access-keys/${key}?env=${env}`], {
    removeTrailingSlash: true,
  })

export const deleteApiKeys = (env, id, key) =>
  del([`source-partners/${id}/api-key/${encodeURIComponent(key)}?env=${env}`], {
    removeTrailingSlash: true,
  })
